import React, { cloneElement } from 'react';
import { render } from 'react-dom';
import { container, collection, root, uid } from './dom-utils';

export const Render = (Component) => {
	const init_placement = Component.props.placement;
	if (!init_placement) return;
	const ComponentContainerName = 'notify-' + init_placement;

	if (!(ComponentContainerName in collection)) {
		collection[ComponentContainerName] = [];
		const placementContainer = root.createElement('div');
		placementContainer.id = ComponentContainerName;
		container.appendChild(placementContainer);
	}

	const {
		id: hasId,
		cancel = false,
		delay,
		timing,
		placement,
		template,
		...props
	} = Component.props;
	// if (hasId && cancel && false) {
	// 	collection[ComponentContainerName] = collection[
	// 		ComponentContainerName
	// 	].filter((notify) => notify.props.id !== hasId);
	// } else
	if (
		hasId &&
		collection[ComponentContainerName].find(
			(notify) => notify.props.id === hasId
		)
	) {
		collection[ComponentContainerName] = collection[ComponentContainerName].map(
			(notify) => {
				return notify.props.id === hasId
					? cloneElement(Component, {
							...notify.props,
							...props,
							key: notify.key,
							cancel,
							template: { ...notify.props.template, ...template }
					  })
					: notify;
			}
		);
	} else if (!cancel) {
		collection[ComponentContainerName][
			ComponentContainerName.includes('top') ? 'push' : 'unshift'
		](cloneElement(Component, { key: uid(), cancel: false }));
	}
	Object.keys(collection).forEach((pContainerName) => {
		const plcontainer = root.getElementById(pContainerName);

		render(
			<>
				{collection[pContainerName].map((notify) => {
					const { onExit, onExiting, onExited } = notify.props;
					return cloneElement(notify, {
						key: notify.key,
						allowRef: true,
						onExit: (target) => {
							onExit && onExit(target);
							if (!target) return;
							const tstyle = target.style;
							tstyle.zIndex = 1032;
							tstyle.height = target.offsetHeight + 'px';
							const animation = `300ms ${(notify.props.timing || 1000) -
								400}ms`;
							tstyle.transition = `height ${animation}, margin-top ${animation}`;
						},
						onExiting: (target) => {
							onExiting && onExiting(target);
							if (!target) return;
							const tstyle = target.style;
							tstyle.zIndex = 1031;
							tstyle.marginTop = tstyle.height = '0';
						},
						onExited: (target) => {
							onExited && onExited(target);
							collection[pContainerName] = collection[pContainerName].filter(
								(each) => each.key !== notify.key
							);
						}
					});
				})}
			</>,
			plcontainer
		);
	});
};

export const RenderHasId = (id) =>
	Object.keys(collection).some((placement) =>
		collection[placement].some((notify) => notify.props.id === id)
	);
